import React from 'react'
import CollectionContainer from '../../containers/PageEditSelection/CollectionContainer'

const CollectionsList = ({collections, selectionID, selectionType, filterValue, filterType, selectionsCinemasFilter, selectionsCinema}) => (
    <div className="periode-list">
        <h3 className="title-list">Wochenauswahl</h3>
        <ul>
            {collections && collections.map((collectionID, index) => (
                <CollectionContainer 
                    key={index}
                    id={collectionID}
                    selectionID={selectionID}
                    selectionType={selectionType}
                    selectionsCinemasFilter={selectionsCinemasFilter}
                    selectionsCinema={selectionsCinema}
                    filterType={filterType}
                    filterValue={filterValue}
                />
            ))}
        </ul>
    </div>
)

export default CollectionsList